import React from 'react';
import { Spinner } from 'react-bootstrap';
import style from './loader.scss';

export const WidgetLoader = ({ loading, children, isRelative }) => (
  <>
    {loading ? (
      <div className={isRelative ? style.relativeContainer : style.container}>
        <Spinner className="loading-indicator" animation="border" role="status" />
      </div>
    ) : (
      React.cloneElement(children, { key: 1 })
    )}
  </>
);
